'use client';

import { useMutation } from '@tanstack/react-query';
import { GORGIAS_SESSION_IDENTITY_QUERIES } from '../../infrastructure/gorgiasSessionIdentity/utils/queries';
import type {
  CreateGorgiasAuthenticatedSessionIdentityResponse,
  CreateGorgiasGuestEmailChallengeRequest,
  CreateGorgiasGuestEmailChallengeResponse,
  VerifyGorgiasGuestEmailChallengeRequest,
  VerifyGorgiasGuestEmailChallengeResponse,
} from '../../infrastructure/gorgiasSessionIdentity/utils/types';

export const useGorgiasSessionIdentityService = () => {
  const useCreateGuestEmailChallenge = () =>
    useMutation<CreateGorgiasGuestEmailChallengeResponse, unknown, CreateGorgiasGuestEmailChallengeRequest>(
      GORGIAS_SESSION_IDENTITY_QUERIES.createGuestEmailChallenge(),
    );

  const useVerifyGuestEmailChallenge = () =>
    useMutation<VerifyGorgiasGuestEmailChallengeResponse, unknown, VerifyGorgiasGuestEmailChallengeRequest>(
      GORGIAS_SESSION_IDENTITY_QUERIES.verifyGuestEmailChallenge(),
    );

  const useCreateAuthenticatedSessionIdentity = () =>
    useMutation<CreateGorgiasAuthenticatedSessionIdentityResponse, unknown, void>(
      GORGIAS_SESSION_IDENTITY_QUERIES.createAuthenticatedSessionIdentity(),
    );

  return {
    useCreateGuestEmailChallenge,
    useVerifyGuestEmailChallenge,
    useCreateAuthenticatedSessionIdentity,
  };
};
